import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useFirebase } from 'components/Firebase/index.js';
import { useAlert } from 'contexts/AlertContext.jsx';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import useOrgId from 'hooks/useOrgId.js';

const useUpdateAvatarMutation = () => {
  const { t } = useLocalization();
  const firebase = useFirebase();
  const orgId = useOrgId();
  const uid = useSelector((state) => state.sessionState.authUser?.uid);
  const queryClient = useQueryClient();
  const { setAlert } = useAlert();

  return useMutation({
    mutationFn: async (avatar) => {
      const agent = await firebase.getAgent();
      const { body } = await agent.post(`/o/${orgId}/users/${uid}/avatar`).send(avatar);
      return body;
    },
    onError: (error) => {
      console.error(error);
      setAlert({ title: t('genericLabels.error'), variant: 'danger' });
    },
    onSuccess: (response) => {
      queryClient.setQueryData(['o', orgId, 'user', uid], (oldData) => ({
        ...oldData,
        avatar: response.avatar.url,
      }));
    },
  });
};

export default useUpdateAvatarMutation;
